import loadComponent from './../utils/loadComponent';
import Signin from './Authentication/Signin';
import ListOutlet from './Outlet/ListOutlet';
import AddEditOutlet from './Outlet/AddEditOutlet';
import ListWorkshopsAMMD from './AMMD/ListWorkshopsAMMD';
import ListTTCApprovalAMMD from './AMMD/ListTTCApprovalAMMD';

// Home
const HomeFCP = loadComponent({ loader: () => import('./Home/HomeFCP') });
const NewHomeFCP = loadComponent({ loader: () => import('./Home/NewHomeFCP') });
const HomeAMMD = loadComponent({ loader: () => import('./Home/HomeAMMD') });

// Apps
const Calendar = loadComponent({ loader: () => import('./Apps/Calendar') });
const Chat = loadComponent({ loader: () => import('./Apps/Chat') });
const Media = loadComponent({ loader: () => import('./Apps/Media') });
const Messages = loadComponent({ loader: () => import('./Apps/Messages') });
const Social = loadComponent({ loader: () => import('./Apps/Social') });

// Charts
const Charts = loadComponent({ loader: () => import('./Charts/Charts') });

// Maps
const Google = loadComponent({ loader: () => import('./Maps/Google') });
const Leaflet = loadComponent({ loader: () => import('./Maps/Leaflet') });

// Pages
const WelcomeFCP = loadComponent({
    loader: () => import('./Pages/WelcomeFCP'),
});
const Guidelines = loadComponent({
    loader: () => import('./Pages/Guidelines'),
});
const WorkshopRules = loadComponent({
    loader: () => import('./Pages/WorkshopRules'),
});
const Blank = loadComponent({ loader: () => import('./Pages/Blank') });
const Invoice = loadComponent({ loader: () => import('./Pages/Invoice') });
const PricingPage = loadComponent({ loader: () => import('./Pages/Pricing') });
const TimelinePage = loadComponent({
    loader: () => import('./Pages/Timeline'),
});
const AddParticipants = loadComponent({
    loader: () => import('./Pages/AddParticipants'),
});
const AddPhotos = loadComponent({ loader: () => import('./Pages/AddPhotos') });
const PlanningWorkshop = loadComponent({
    loader: () => import('./Pages/PlanningWorkshop'),
});
const Workshop = loadComponent({ loader: () => import('./Pages/Workshop') });
const Notifications = loadComponent({
    loader: () => import('./Pages/Notifications'),
});
const Funds = loadComponent({ loader: () => import('./Funds/Funds') });
const Profile = loadComponent({ loader: () => import('./Profile/Profile') });
const NewProfile = loadComponent({
    loader: () => import('./Profile/NewProfile'),
});
const ContactUs = loadComponent({ loader: () => import('./ContactUs') });
const ListLead = loadComponent({ loader: () => import('./Leads/ListLead') });
const Lead = loadComponent({ loader: () => import('./Leads/Lead') });
const ViewFCPLeads = loadComponent({
    loader: () => import('./FCPLeads/ViewFCPLeads'),
});
const ViewFCP = loadComponent({ loader: () => import('./FCPLeads/ViewFCP') });
const ListMyFCP = loadComponent({ loader: () => import('./MyFCP/ListMyFCP') });
const MyFCP = loadComponent({ loader: () => import('./MyFCP/MyFCP') });
const ViewWorkshopDetails = loadComponent({
    loader: () => import('./MyFCP/ViewWorkshopDetails'),
});
const CreateContainer = loadComponent({
    loader: () => import('./Training/CreateContainer'),
});
const ExecuteTraining = loadComponent({
    loader: () => import('./Training/ExecuteTraining'),
});
const AddTrainingPhotos = loadComponent({
    loader: () => import('./Training/AddTrainingPhotos'),
});
const ViewContainer = loadComponent({
    loader: () => import('./Training/ViewContainer'),
});
const ListWorkshopCMDI = loadComponent({
    loader: () => import('./Pages/ListWorkshopCMDI'),
});
const Reports = loadComponent({ loader: () => import('./Pages/Reports') });
const HomeCMDI = loadComponent({ loader: () => import('./Home/HomeCMDI') });
const Training = loadComponent({ loader: () => import('./Training/Training') });
const ListPayments = loadComponent({
    loader: () => import('./Payments/ListPayments'),
});
const ListAssignLead = loadComponent({
    loader: () => import('./AMMD/ListAssignLead'),
});
const ListFCPEventsPlanned = loadComponent({
    loader: () => import('./Pages/ListFCPEventsPlanned'),
});
const ListFCPAssignedHPA = loadComponent({
    loader: () => import('./FCP/ListFCPAssignedHPA'),
});
const AssingedHPA = loadComponent({
    loader: () => import('./FCP/AssingedHPA'),
});
const AddFCPHPA = loadComponent({ loader: () => import('./FCP/AddFCPHPA') });
const AddNewHPA = loadComponent({ loader: () => import('./FCP/AddNewHPA') });
const ListHPA = loadComponent({ loader: () => import('./HPA/HPAList') });
const AddNewSchool = loadComponent({ loader: () => import("./School/AddNewSchool") })
const SchoolList = loadComponent({ loader: () => import("./School/SchoolList") })
const Content = loadComponent({ loader: () => import('./Content/Content') });
// const ListOutlet = loadComponent({loader:()=> import("./Outlet/ListOutlet")})
// const AddEditOutlet = loadComponent({loader:()=>import("./Outlet/AddEditOutlet")})

// Taskboard
const Taskboard = loadComponent({
    loader: () => import('./Taskboard/Taskboard'),
});

// Widgets
const Widgets = loadComponent({ loader: () => import('./Widgets/Widgets') });

// Form
const Editor = loadComponent({ loader: () => import('./Forms/Editor') });

// Authentication
const ForgetPassword = loadComponent({
    loader: () => import('./Authentication/ForgetPassword'),
});
const Lockscreen = loadComponent({
    loader: () => import('./Authentication/Lockscreen'),
});
const PasswordReset = loadComponent({
    loader: () => import('./Authentication/PasswordReset'),
});
const Signup = loadComponent({
    loader: () => import('./Authentication/Signup'),
});

// Error
const NotFound = loadComponent({ loader: () => import('./Errors/NotFound') });

const BackendError = loadComponent({
    loader: () => import('./Errors/BackendError'),
});

// Ecommerce
const Products = loadComponent({
    loader: () => import('./Ecommerce/Products'),
});
const Detail = loadComponent({ loader: () => import('./Ecommerce/Detail') });

// Material Examples
const AppBar = loadComponent({ loader: () => import('./Material/app-bar') });
const Autocomplete = loadComponent({
    loader: () => import('./Material/autocomplete'),
});
const Avatars = loadComponent({ loader: () => import('./Material/avatars') });
const Badges = loadComponent({ loader: () => import('./Material/badges') });
const ButtonNavigation = loadComponent({
    loader: () => import('./Material/bottom-navigation'),
});
const Buttons = loadComponent({ loader: () => import('./Material/buttons') });
const Cards = loadComponent({ loader: () => import('./Material/cards') });
const Chips = loadComponent({ loader: () => import('./Material/chips') });
const Dialogs = loadComponent({ loader: () => import('./Material/dialogs') });
const Dividers = loadComponent({ loader: () => import('./Material/dividers') });
const Drawers = loadComponent({ loader: () => import('./Material/drawers') });
const ExpansionPanels = loadComponent({
    loader: () => import('./Material/expansion-panels'),
});
const GridList = loadComponent({
    loader: () => import('./Material/grid-list'),
});
const Lists = loadComponent({ loader: () => import('./Material/lists') });
const Menus = loadComponent({ loader: () => import('./Material/menus') });
const Paper = loadComponent({ loader: () => import('./Material/paper') });
const Pickers = loadComponent({ loader: () => import('./Material/pickers') });
const Progress = loadComponent({ loader: () => import('./Material/progress') });
const SelectionControls = loadComponent({
    loader: () => import('./Material/selection-controls'),
});
const Selects = loadComponent({ loader: () => import('./Material/selects') });
const Snackbars = loadComponent({
    loader: () => import('./Material/snackbars'),
});
const Steppers = loadComponent({ loader: () => import('./Material/steppers') });
const Tables = loadComponent({ loader: () => import('./Material/tables') });
const Tabs = loadComponent({ loader: () => import('./Material/tabs') });
const TextFields = loadComponent({
    loader: () => import('./Material/text-fields'),
});
const Tooltips = loadComponent({ loader: () => import('./Material/tooltips') });

export {
  HomeFCP,
  NewHomeFCP,
  HomeAMMD,
  Calendar,
  Chat,
  Media,
  Messages,
  Social,
  Google,
  Leaflet,
  WelcomeFCP,
  Guidelines,
  WorkshopRules,
  Blank,
  Invoice,
  PricingPage,
  TimelinePage,
  Taskboard,
  Widgets,
  Charts,
  Editor,
  ForgetPassword,
  Lockscreen,
  PasswordReset,
  Signin,
  Signup,
  NotFound,
  BackendError,
  Products,
  Detail,
  AddParticipants,
  AddPhotos,
  AppBar,
  Autocomplete,
  Avatars,
  Badges,
  ButtonNavigation,
  Buttons,
  Cards,
  Chips,
  Dialogs,
  Dividers,
  Drawers,
  ExpansionPanels,
  GridList,
  Lists,
  Menus,
  Paper,
  Pickers,
  Progress,
  SelectionControls,
  Selects,
  Snackbars,
  Steppers,
  Tables,
  Tabs,
  TextFields,
  Tooltips,
  PlanningWorkshop,
  Notifications,
  Funds,
  Profile,
  NewProfile,
  ContactUs,
  Workshop,
  ListLead,
  Lead,
  ViewFCP,
  ViewFCPLeads,
  ListMyFCP,
  MyFCP,
  ViewWorkshopDetails,
  CreateContainer,
  ViewContainer,
  ListWorkshopCMDI,
  Reports,
  HomeCMDI,
  Training,
  ListPayments,
  ListAssignLead,
  ListFCPEventsPlanned,
  ListFCPAssignedHPA,
  AssingedHPA,
  AddFCPHPA,
  AddNewHPA,
  ListHPA,
  AddNewSchool,
  SchoolList,
  Content,
  ExecuteTraining,
  AddTrainingPhotos,
  ListOutlet,
  AddEditOutlet,
  ListWorkshopsAMMD,
  ListTTCApprovalAMMD
};
